export const THREADS_ACTION_ICON_PATHS: string[] = [
  'socialmedia/like-icon-threads.svg',
  'socialmedia/comment-icon-threads.svg',
  'socialmedia/repost-icon-threads.svg',
  'socialmedia/share-icon-threads.svg',
];

export const THREADS_FOLLOW_ICON_PATH = 'socialmedia/follow-icon-threads.svg';
